import { render, staticRenderFns } from "./configMenu.vue?vue&type=template&id=ef786fdc&scoped=true"
import script from "./configMenu.vue?vue&type=script&lang=js"
export * from "./configMenu.vue?vue&type=script&lang=js"
import style0 from "./configMenu.vue?vue&type=style&index=0&id=ef786fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef786fdc",
  null
  
)

export default component.exports